<template>
        <contract-material-summary-values
            :material-combined="materialCombined"
            :attribute="attribute"
            :hide-buttons="hideButtons"
            @emitShowAddMaterialReport="$emit('emitShowAddMaterialReport')"
            @emitDownloadMaterialReportExcel="$emit('emitDownloadMaterialReportExcel')"
        />
</template>

<script>
import ContractMaterialSummaryValues from "@/components/contractreport/ContractMaterialSummaryValues.vue";
import {materialReportHelper, materialReportUnitString} from "@/components/mixins/MaterialReportMixin";

export default {
    name: "ContractMaterialSummary",
    mixins: [materialReportHelper],
    components: {ContractMaterialSummaryValues},
    props: {
        results: {
            type: Array,
            default: function () {
                return []
            }
        },
        attribute: {
            type: String,
            default: function () {
                return materialReportUnitString.MATERIAL
            }
        },
        hideButtons: {
            type: Boolean,
            default: function () {
                return false
            }
        }
    },
    data: function () {
        return {
            materialCombined: [],
        }
    },

    created() {
        this.handleResponse()
    },

    watch: {
        results: function () {
            this.handleResponse()
        }
    },
    methods: {
        calculateMaterialSummary() {
            this.materialCombined = this.sumByAttribute(this.results, this.attribute)
        },

        sumByAttribute(results, attribute) {
            const summedAttributes = {};

            results.forEach(item => {
                const { amount, unit } = item;
                const attributeValue = item[attribute];

                // Ensure the attribute exists in the summedAttributes object
                if (!summedAttributes[attributeValue]) {
                    summedAttributes[attributeValue] = { amount: 0, unit };
                }

                // Convert units if necessary
                if (unit === 't' && summedAttributes[attributeValue].unit === 'kg') {
                    summedAttributes[attributeValue].amount += amount * 1000;
                } else if (unit === 'kg' && summedAttributes[attributeValue].unit === 't') {
                    summedAttributes[attributeValue].amount += amount / 1000;
                } else if (unit === summedAttributes[attributeValue].unit) {
                    summedAttributes[attributeValue].amount += amount;
                }
            });

            return Object.keys(summedAttributes).map(key => ({
                [attribute]: key,
                amount: summedAttributes[key].amount,
                unit: summedAttributes[key].unit
            }));
        },

        handleResponse: function () {
            this.materialCombined = []
            this.calculateMaterialSummary()
        },
    }
}
</script>

